import React, { forwardRef } from "react";
import { Box, Typography, Checkbox as MuiCheckbox } from "@mui/material";
import { CheckboxContainer, CheckboxLabel } from "./Checkbox.styled";

interface CheckboxProps {
  label?: string | React.ReactNode;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  name?: string;
  id?: string;
  size?: "small" | "medium";
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning";
}

const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
  (
    {
      label,
      checked = false,
      onChange,
      disabled = false,
      required = false,
      error = false,
      helperText,
      name,
      id,
      size = "medium",
      color = "primary",
    },
    ref,
  ) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(event.target.checked);
    };

    return (
      <Box>
        <CheckboxContainer>
          <MuiCheckbox
            ref={ref}
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
            name={name}
            id={id}
            size={size}
            color={error ? "error" : color}
            sx={{
              padding: 0,
              "&.Mui-checked": {
                color: error ? "error.main" : "primary.main",
              },
            }}
          />
          {label && (
            <CheckboxLabel
              onClick={() => !disabled && onChange?.(!checked)}
              sx={{ cursor: disabled ? "default" : "pointer" }}
            >
              {typeof label === "string" ? (
                <>
                  {label}
                  {required && (
                    <Box component="span" sx={{ color: "inherit" }}>
                      {" "}
                      *
                    </Box>
                  )}
                </>
              ) : (
                label
              )}
            </CheckboxLabel>
          )}
        </CheckboxContainer>
        {helperText && (
          <Typography
            variant="caption"
            sx={{
              color: error ? "error.main" : "text.secondary",
              fontSize: "12px",
              mt: 0.5,
              display: "block",
            }}
          >
            {helperText}
          </Typography>
        )}
      </Box>
    );
  },
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
